import { Link } from "react-router-dom";
import { Database, Network, Search } from "lucide-react";
import { Explorer } from "@/pages/migrations/Explorer";

export function StudioMetadataPage() {
  return (
    <div className="space-y-6">
      <section className="studio-hero">
        <div>
          <div className="studio-eyebrow">Metadata - graph aware</div>
          <h1 className="studio-title">
            Metadata explorer <em>inside Studio.</em>
          </h1>
          <p className="studio-subtitle">
            Search objects, classes, flows, and triggers, then jump into graph impact or a prefilled migration run.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to="/org360" className="studio-button">
            <Network className="h-4 w-4" />
            Org 360
          </Link>
          <Link to="/migrations/smart_metadata_explorer" className="studio-button studio-button-primary">
            <Search className="h-4 w-4" />
            Smart explorer
          </Link>
        </div>
      </section>

      <div className="grid gap-4 md:grid-cols-3">
        <Metric icon={<Database className="h-4 w-4" />} label="Scope" value="objects, Apex, flows" />
        <Metric icon={<Network className="h-4 w-4" />} label="Graph" value="impact + references" />
        <Metric icon={<Search className="h-4 w-4" />} label="Actions" value="run migrations" />
      </div>

      <Explorer />
    </div>
  );
}

function Metric({ icon, label, value }: { icon: React.ReactNode; label: string; value: string }) {
  return (
    <div className="studio-card p-4">
      <div className="mb-3 inline-flex h-9 w-9 items-center justify-center rounded-md bg-muted text-foreground">{icon}</div>
      <div className="text-xs font-semibold uppercase text-muted-foreground">{label}</div>
      <div className="mt-1 text-sm font-semibold">{value}</div>
    </div>
  );
}
